// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Wdga","productName":"Table_productName__1RJMq"};